import { render, staticRenderFns } from "./UserUpdate.vue?vue&type=template&id=1229b4a8&scoped=true&"
import script from "./UserUpdate.vue?vue&type=script&lang=js&"
export * from "./UserUpdate.vue?vue&type=script&lang=js&"
import style0 from "./UserUpdate.vue?vue&type=style&index=0&id=1229b4a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1229b4a8",
  null
  
)

export default component.exports